module.exports = __webpack_public_path__ + "img/bg.b12cbe5f.png";